import { render, staticRenderFns } from "./TabsSong.vue?vue&type=template&id=1cb0fab4"
import script from "./TabsSong.vue?vue&type=script&lang=js"
export * from "./TabsSong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports